























































































































import { Component, Vue } from 'vue-property-decorator'
import HeaderNavigationDropdown from '@/components/layout/header/navigation/HeaderNavigationDropdown.vue'
import RouteName from '@/utils/RouteName'
import TranslationModule from '@/utils/TranslationModule'
import HeaderNavigationItemTitle from '@/components/layout/header/navigation/HeaderNavigationItemTitle.vue'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import { Header } from '@/types/Header.type'
import { namespace } from 'vuex-class'
import { UserRole } from '@/types/UserRole.type'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

const User = namespace('user')

@Component({
    components: { EvaIcon, HeaderNavigationItemTitle, HeaderNavigationDropdown, BaseIcon },
})
export default class HeaderInvestmentNavigation extends Vue {
    RouteName: typeof RouteName = RouteName
    TranslationModule: typeof TranslationModule = TranslationModule
    @User.Getter hasRole!: (role: UserRole) => boolean

    INVESTORS_CLUB_ID = 4
    VC_CIRCLE_CLUB_ID = 15

    get config(): Header | null {
        return this.$store.state.app.headerConfiguration
    }

    get investorsClub(): { id: number | string; name: string; slug: string } | null | undefined {
        return this.config && this.config.clubs.find(club => club.id === this.INVESTORS_CLUB_ID)
    }

    get vcCircleClub(): { id: number | string; name: string; slug: string } | null | undefined {
        return this.config && this.config.clubs.find(club => club.id === this.VC_CIRCLE_CLUB_ID)
    }
}
